<template>
  <div>
    <v-select v-model="customer" label="Reception" :filterable="false"
              :on-change="$emit('customer-change', customer.Id)"
              :options="customers" @search="onSearch"
    >
      <template slot="no-options">
        начните вводить приемный пункт...
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          {{ option.Reception }} ({{option['CustomerGroupName']}})
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.Reception }} ({{option['CustomerGroupName']}})
        </div>
      </template>
      <template #search="{attributes, events}">
        <input
            class="vs__search"
            :required="!customer"
            v-bind="attributes"
            v-on="events"
            v-on:keydown.enter.prevent
        />
      </template>
    </v-select>
  </div>
</template>

<script>
import _ from 'lodash';
import { get } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/order-add-form`;

export default {
  props: ['orderId'],
  data() {
    return {
      customer: {},
      customers: [],
    };
  },
  watch: {
    async orderId(newVal) {
      console.log('orderId', newVal)
      if (newVal) {
        await this.fetchCustomer();
      }
    },
    // customer(newVal) {
    //   if (newVal) {
    //     this.$emit('customer-change', newVal.Id);
    //   }
    // },
  },
  methods: {
    async fetchCustomer() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order/${this.orderId}/customer`);
      this.customer = data;
    },
    onSearch(search, loading) {
      if (!search) {
        return;
      }
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      get(`${url}/search-customers?q=${(search)}`)
        .then((res) => {
          vm.customers = res.data;
          loading(false);
        });
    }, 350),
  },
};
</script>
